import React, { useEffect, useState } from 'react'
import { Col, Form, Row, FormInstance } from 'antd'
import UploadDocument from 'components/global/UploadDocument'
import { Photo } from 'types/globalTypes'
import { defaultIconStore } from 'state/listing/defaultIcon'
import {
  useCreateDefaultIcon,
  useUpdateDefaultIcon,
} from 'api/Listings/DefaultIcon'
import { myStore } from 'state/store'

interface AddDefaultIconFormProps {
  form: FormInstance
}

const AddDefaultIconForm: React.FC<AddDefaultIconFormProps> = ({ form }) => {
  const { iconFor, defaultData, setModal } = defaultIconStore(store => ({
    iconFor: store.iconFor,
    defaultData: store.defaultData,
    setModal: store.setAddDefaultIconModal,
  }))
  const setModalBtnLoader = myStore(store => store.setModalBtnLoader)
  const [error, setError] = useState<string>('')
  const [documentIds, setDocumentIds] = useState<string[]>(
    defaultData ? [defaultData.iconId] : [],
  )
  const [photos] = useState<Photo[]>(defaultData ? [defaultData.icon] : [])
  const { mutate: addDefaultIcon } = useCreateDefaultIcon()
  const { mutate: updateDefaultIcon } = useUpdateDefaultIcon()

  const handleFinish = () => {
    if (documentIds.length === 0) {
      setError('Icon is required')
      return
    }
    const payload = {
      iconFor,
      iconId: documentIds[0],
    }
    setModalBtnLoader(true)

    if (defaultData) {
      updateDefaultIcon(
        { id: defaultData._id, payload },
        {
          onSuccess: () => {
            setModalBtnLoader(false)
            setModal(false)
          },
          onError: () => {
            setModalBtnLoader(false)
            setModal(false)
          },
        },
      )
    } else {
      addDefaultIcon(payload, {
        onSuccess: () => {
          setModalBtnLoader(false)
          setModal(false)
        },
        onError: () => {
          setModalBtnLoader(false)
          setModal(false)
        },
      })
    }
  }

  useEffect(() => {
    if (documentIds.length) {
      setError('')
    }
  }, [documentIds])

  return (
    <Form
      form={form}
      layout="vertical"
      autoComplete="off"
      onFinish={handleFinish}
    >
      <Row>
        <Col>
          <label className="custom-field-label required-input">Add Icon</label>
        </Col>
        <Col span={12}>
          <UploadDocument
            documentIds={documentIds}
            setDocumentIds={setDocumentIds}
            multiple={false}
            docType="image/*"
            files={photos}
            soruceType={'icon'}
          />
        </Col>
        {error && (
          <Col className="-mt-20px" span={24}>
            <p className="ant-form-item-explain-error">{error}</p>
          </Col>
        )}
      </Row>
    </Form>
  )
}

export default AddDefaultIconForm
